import { useState, useEffect } from 'react';

export type DomainType = 'main' | 'news';

export const useDomain = (): DomainType => {
  const [domain, setDomain] = useState<DomainType>('main');

  useEffect(() => {
    const hostname = window.location.hostname;
    
    if (hostname.includes('news.nexx.net')) {
      setDomain('news');
    } else {
      setDomain('main');
    }
  }, []);

  return domain;
};

export const isDomain = (type: DomainType): boolean => {
  if (typeof window === 'undefined') return false;
  
  const hostname = window.location.hostname;
  
  switch (type) {
    case 'news':
      return hostname.includes('news.nexx.net');
    case 'main':
    default:
      return !hostname.includes('news.nexx.net');
  }
};